import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import enTranslation from './langs/en.json';

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: enTranslation },
  },
  fallbackLng: 'en',
});

export { i18n };
